export default "__VITE_ASSET__CvuV4erM__"